export default "<span class=\"ysh-button-wrapper\"><ng-content></ng-content></span>\n";